
export const uniqueOptions = (arr) =>
  [...new Map(arr.map(item => [item.value, item])).values()];


export const getChainedAccessOptions = (structure, selections) => {
  const { legal, business, vertical } = selections;

  // 1) Filter legal entity rows
  const filteredLegalEntities = structure.filter(item =>
    legal.includes(item.legal_entity)
  );

  // 2) Business Unit options
  const businessUnitOptions = uniqueOptions(
    filteredLegalEntities.flatMap(item =>
      item.business_units.map(bu => ({
        value: bu.business_unit,
        label: bu.business_unit
      }))
    )
  );

  // 3) Business Unit objects for deeper filtering
  const businessUnitObjects = filteredLegalEntities
    .flatMap(item => item.business_units)
    .filter(bu => business.includes(bu.business_unit));

  // 4) Vertical options
  const verticalOptions = uniqueOptions(
    businessUnitObjects.flatMap(bu =>
      bu.functions.map(func => ({
        value: func.function,
        label: func.function
      }))
    )
  );

  // 5) Vertical objects for deeper filtering
  const verticalObjects = businessUnitObjects
    .flatMap(bu => bu.functions)
    .filter(func => vertical.includes(func.function));

  // 6) Team options
  const teamOptions = uniqueOptions(
    verticalObjects.flatMap(func =>
      func.sub_functions.map(sub => ({
        value: sub.sub_function,
        label: sub.sub_function
      }))
    )
  );

  return {
    businessUnitOptions,
    verticalOptions,
    teamOptions
  };
};

// Removes any selected values that are NOT in validOptions
export const filterSelectedByValidOptions = (selectedValues, validOptions) => {
  const validList = validOptions.map(opt => opt.value);
  return selectedValues.filter(val => validList.includes(val));
};

export const capitalizeEachWord = (text = "") => {
  if (!text) return "";

  return text
    .toLowerCase()
    .split(" ")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const normalizeRoleEntitlements = (data) => ({
  roleId: data.role_id,
  roleName: data.role_name,
  description: data.description,
  featureId: data.feature_id,
  entitlementIds: data.entitlement_ids || [],
  businessUnit: Array.isArray(data.business_unit) ? data.business_unit :data.business_unit?.split(",")|| [],
  function: Array.isArray(data.function) ? data.function : data.function?.split(",")|| [],
  subFunction: Array.isArray(data.sub_function) ? data.sub_function : data.sub_function?.split(",") || [],
  legalEntity: Array.isArray(data.legal_entity) ? data.legal_entity : data.legal_entity?.split(",")|| [],
});

export const normalizeFeatureEntitlements = (data) => {
  const { feature_id, feature_name, groups = [] } = data;

  return {
    featureId: feature_id,
    featureName: feature_name,
    groups: groups.map(group => ({
      groupId: group.group_id,
      groupName: group.group_name,
      displayOrder: group.display_order,
      visible: group.visible,
      entitlements: (group.entitlements || []).map(ent => ({
        entitlementId: ent.entitlement_id,
        visible: ent.visible
      }))
    }))
  };
};

export const sleep = (ms) =>{
  return new Promise(resolve => setTimeout(resolve, ms));
}